import { useEffect } from 'react';
import { useParams } from 'react-router';

import { useGetCompetitionStructureQuery } from 'api/fspApi';
import { FixturesAndResults } from 'components/FixturesAndResults';
import Notfound from 'routes/notfound';
import config from 'utils/config';

type Params = {
  competitionName: string;
  seasonYear: string;
};

const Competition = () => {
  const { competitionName, seasonYear: urlSeasonYear } = useParams<Params>();
  const seasonYear = urlSeasonYear ?? new Date().getFullYear().toString();

  const competition = config.competitions.find((item) => item.name === competitionName);

  useEffect(() => {
    if (!competition) return;
    import(
      `../../../node_modules/@uefadigital/panenka-base/dist/css/competitions/${competition.shortName}/${competition.shortName}.css`
    );
  }, [competition]);

  const { error: competitionIsError, isLoading: competitionLoading } = useGetCompetitionStructureQuery(
    {
      id: competition!.id,
      seasonYear,
    },
    { skip: !competition },
  );

  if (!competition) {
    return <Notfound />;
  }

  if (competitionLoading) {
    return <div />;
  }

  if (competitionIsError) {
    return <Notfound />;
  }

  return (
    <div pk-competition={competition.shortName} pk-theme="light" className="pk-bg--background">
      <FixturesAndResults
        competitionId={competition.id}
        competitionShortName={competition.shortName}
        competitionName={competition.name}
        seasonYear={seasonYear}
        competitionType={competition.type}
        competitionLogo={competition.logo}
      />
    </div>
  );
};

export default Competition;
